import theme from 'src/styles/theme'
import styled from 'styled-components'
import { Col, Row } from 'reactstrap'
import { Button } from '@mui/material'

export const FiltersForm = styled.form`
    background: ${theme.colors.white};
    padding: 16px;
    border-radius: 8px;
    display: flex;
    flex-direction: column;
`

export const FilterActions = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 8px;
`

export const FlexCol = styled(Col)`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    padding: 8px;
    gap: 16px;
`

export const FilterButton = styled(Button)`
    background: ${theme.colors.blue} !important;
    color: ${theme.colors.white} !important;
    width: 10rem;
`

export const CustomRow = styled(Row)`
    padding: 0 8px;
`
